import React, { useEffect, useState } from 'react';
import {
  DefaultButton,
  PrimaryButton,
  TextField,
} from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';

const DeclineCommentResponse = ({
  isOpen,
  commentDeclineReason,
  commentDecliner,
  onChangeText,
  cancelDeclineComment,
  confirmDeclineComment,
  isEditMode,
  hasDeclineReason,
}) => {
  const { t: translator } = useTranslation();

  const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);

  useEffect(() => {
    const enableConfirmation =
      commentDeclineReason !== null && commentDeclineReason.trim().length !== 0;
    setIsConfirmEnabled(enableConfirmation);
  }, [commentDeclineReason]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="hearing-response-box--is-reply">
      <div>
        {isEditMode ? (
          <>
            <>
              <h3>{translator('pages.hearingDetails.declineCommentHeader')}</h3>
              <p>{translator('pages.hearingDetails.declineCommentText')}</p>
            </>
            <TextField
              value={commentDeclineReason}
              onChange={(_, value) => onChangeText(value)}
              multiline
              styles={textFieldStyles}
            />
            <div className="panel-buttons--no-padding">
              <DefaultButton
                text={translator('global.cancel')}
                onClick={cancelDeclineComment}
              />
              <PrimaryButton
                text={translator('global.confirm')}
                disabled={!isConfirmEnabled}
                onClick={confirmDeclineComment}
              />
            </div>
          </>
        ) : hasDeclineReason ? (
          <>
            {!!commentDecliner ? (
              <h3>
                {translator(
                  'pages.hearingDetails.declinedCommentHeaderWithPreface',
                )}
                {commentDecliner}
              </h3>
            ) : null}
            <h3>{translator('pages.hearingDetails.declineCommentHeader')}</h3>
            <p>
              <strong>
                {translator('pages.hearingDetails.declineCommentReason')}
              </strong>
              <i>{commentDeclineReason}</i>
            </p>
          </>
        ) : (
          <>
            <h3>{translator('pages.hearingDetails.declineCommentHeader')}</h3>
            <p>{translator('pages.hearingDetails.declineCommentNoReason')}</p>
          </>
        )}
      </div>
    </div>
  );
};

const textFieldStyles = {
  root: {
    marginBottom: '20px',
  },
  field: {
    minHeight: '100px',
    maxHeight: '300px',
  },
};

export { DeclineCommentResponse };
